export default __webpack_public_path__ + "static/ricta3-ec7f175bb8817203d9e32142fa81e25b.svg";